import JSZip from "jszip";

function escapeHtml(s = "") {
  return String(s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function renderElement(el) {
  const styleParts = [
    `position:absolute`,
    `left:${el.x}px`,
    `top:${el.y}px`,
    `width:${el.w}px`,
    `height:${el.h}px`,
  ];
  if (el.rotation) styleParts.push(`transform:rotate(${el.rotation}deg)`);

  let inner = "";
  if (el.type === "text") {
    const s = [
      `font-size:${el.fontSize || 18}px`,
      `font-weight:${el.fontWeight || 400}`,
      `color:${el.color || "#111827"}`,
      `text-align:${el.align || "left"}`,
      `font-family:${el.fontFamily || "system-ui, sans-serif"}`,
      `line-height:1.3`,
      `width:100%`,
      `height:100%`,
    ].join(";");
    inner = `<div style="${s}">${escapeHtml(el.text || "")}</div>`;
  } else if (el.type === "image") {
    inner = `<img src="${el.src}" style="width:100%;height:100%;object-fit:${el.fit || "cover"}" alt="" />`;
  } else if (el.type === "shape") {
    const radius = el.shape === "circle" ? "50%" : `${el.radius || 8}px`;
    const border = el.stroke ? `border:${el.strokeWidth || 1}px solid ${el.stroke};` : "";
    inner = `<div style="width:100%;height:100%;background:${el.fill || "#002FA7"};border-radius:${radius};${border}"></div>`;
  } else if (el.type === "button") {
    inner = `<div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;border-radius:8px;background:${el.fill || "#002FA7"};color:${el.color || "#fff"};font-weight:600">${escapeHtml(el.text || "Button")}</div>`;
  }

  const wrapper = `<div style="${styleParts.join(";")}">${inner}</div>`;
  if (el.href) {
    return `<a href="${el.href}" target="_blank" rel="noopener noreferrer" style="${styleParts.join(";")};display:block">${inner}</a>`;
  }
  return wrapper;
}

function renderPage(page, idx) {
  const bg = page.backgroundImage
    ? `background:url('${page.backgroundImage}') center/cover no-repeat;`
    : `background:${page.background || "#FFFFFF"};`;
  const els = (page.elements || []).map(renderElement).join("\n");
  return `<section data-page="${idx + 1}" style="position:relative;width:100%;max-width:1024px;margin:0 auto;height:768px;${bg}">${els}</section>`;
}

function renderHtml(project) {
  const pagesHtml = (project.pages || []).map(renderPage).join("\n");
  return `<!doctype html>
<html lang="en"><head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1" />
<title>${escapeHtml(project.projectName || "Untitled site")}</title>
<style>
*{box-sizing:border-box} html,body{margin:0;padding:0;background:#f3f4f6;font-family:system-ui,-apple-system,Segoe UI,Roboto,sans-serif}
img{display:block}
section{box-shadow:0 4px 24px rgba(0,0,0,.06)}
@media (max-width:1080px){ section{transform-origin:top center;transform:scale(.85);margin-bottom:-100px} }
@media (max-width:780px){ section{transform:scale(.55);margin-bottom:-340px} }
</style>
</head><body>
${pagesHtml}
</body></html>`;
}

export default async function buildExport(state) {
  const zip = new JSZip();
  zip.file("index.html", renderHtml(state));
  zip.file(
    "project.json",
    JSON.stringify(
      { name: state.projectName, pages: state.pages },
      null,
      2,
    ),
  );
  zip.file("README.txt", `CreativeHub export\nProject: ${state.projectName}\nOpen index.html to view.\n`);

  const blob = await zip.generateAsync({ type: "blob" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  const safe = (state.projectName || "creativehub").toLowerCase().replace(/[^a-z0-9-]+/g, "-");
  a.download = `${safe}.zip`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
